module.exports = __webpack_public_path__ + "img/Location House.e44ed280.svg";